export default {
  readers: [
    'GradeControlReaders',
    'Admin'
  ],
  collaborators: [
    'GradeControlCollaborators',
    'Admin'
  ],
  samples: [
    'SamplesWriters',
    'Admin'
  ],
  samplesOrCollaborators: [
    'GradeControlCollaborators',
    'SamplesWriters',
    'Admin'
  ],
  employeesCollaborators : [
    'EmployeesWriters',
    'Admin'
  ]
}
